import { Component, OnInit, ViewChild } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Observable, Subject } from 'rxjs';
import { map, takeUntil } from 'rxjs/operators';
import { Portal } from 'src/app/models/entities/portal';
import { PortalService } from 'src/app/services/portal.service';

@Component({
  selector: 'app-portal',
  templateUrl: './portal.component.html',
  styleUrls: ['./portal.component.css']
})
export class PortalComponent implements OnInit {

  destroy$ = new Subject<void>();
  deleteModal: boolean;
  portalId: number;
  portals$: Observable<Portal[]>;
  @ViewChild('dt', { static: false }) dt: any;
  constructor(private portalService: PortalService, private toastrService: ToastrService) { }

  ngOnInit(): void {
    this.getList();
  }

  getList() {
    this.portals$ = this.portalService.getList().pipe(map(result => result.data));
  }

  applyFilterGlobal($event: Event, stringVal: string) {
    this.dt.filterGlobal(($event.target as HTMLInputElement).value, 'contains');
  }

  showDeleteModal(portalId: number) {
    this.deleteModal = true;
    this.portalId = portalId;
  }

  deletePortal() {
    this.deleteModal = false;
    this.portalService.delete(this.portalId).pipe(takeUntil(this.destroy$)).subscribe(
      result => {
        this.toastrService.success(result.message, "BAŞARILI!");
        this.getList();
      },
      er => {
        this.toastrService.error(er.error.message, "HATA!");
      }
    )
  }

}
